export const BASE_URL = 'https://api.ikeyedutech.com.my/';
